import type { FaireProductEntity } from "../../entity_types/product";

export const p_g7q77dmaym: FaireProductEntity = {
  token: "p_g7q77dmaym",
  type: "product",
  name: "GGO-2819 Joy Snowlady L/S  -  Red",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/c96b34c49e38104b5f154bef85da23cd04c7a7eff189fdd6fd7ee99a16a59efc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/77e800951faef992ed6d6c87b8bf9e7455a1dceb89360e80f6e557a83c4c9e5f.png"
  ],
  priceDollars: 11,
  description: "Spread a little joy this holiday season with our adorable \"Joy to the World\" Long Sleeve T-Shirt! Featuring a cute and festive snowlady design with the cheerful saying \"Joy to the World,\" this tee is the perfect way to celebrate the most wonderful time of the year! Made from 100% cotton!\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:09.230Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
